/* Photo strip on the phone PDP (snippets/pdp-minimap.liquid). Light on
   purpose: geometry is measured once (and again on resize or when the
   page's height changes), every scroll only does arithmetic on the cached
   numbers and writes two CSS variables. The lit layer and the ring follow
   those variables; nothing toggles per thumbnail. */
(function () {
  'use strict';
  if (!window.matchMedia('(max-width: 900px)').matches) return;
  var nav = document.querySelector('[data-pdp-minimap]');
  if (!nav) return;
  var stage = document.querySelector('.v-pdp__model-stage');
  var frames = Array.prototype.slice.call(document.querySelectorAll('.v-pdp__media .v-pdp__media-item:not(.v-pdp__media-item--placeholder)'));
  var targets = (stage ? [stage] : []).concat(frames);
  var thumbs = Array.prototype.slice.call(nav.querySelectorAll('.v-pdp-minimap__dim > [data-minimap-i]'));
  if (!targets.length || thumbs.length !== targets.length) return;
  nav.removeAttribute('hidden');
  /* Usage events (Aditya, 2026-11-04: "how many people actually use it"):
     strip_shown once per page when it first appears, strip_tap for a
     thumbnail jump, strip_scrub when a drag ends. Same base params as
     tz-track.js (page, handle, variant, state) so they read beside the rest. */
  var sent = {};
  var track = function (name, extra) {
    if (typeof window.gtag !== 'function') return;
    var pdp = document.querySelector('.v-pdp[data-product-handle]');
    var p = { page: 'product', handle: pdp ? pdp.getAttribute('data-product-handle') : '', state: document.body.getAttribute('data-pdp-sheet-state') || 'none' };
    var ab = document.documentElement.getAttribute('data-ab-fw'); if (ab) p.variant = ab;
    for (var k in extra) if (extra[k] !== undefined && extra[k] !== '') p[k] = extra[k];
    try { window.gtag('event', name, p); } catch (err) { /* analytics never breaks the page */ }
  };

  var F = [], S = [], navTop = 0, navH = 0, docH = 0;
  var pinned = function () { return document.body.hasAttribute('data-pdp-pinned') || (stage && getComputedStyle(stage).position === 'fixed'); };
  var measure = function () {
    /* While the photos are pinned (position: fixed under the Expanded sheet)
       their rects do not describe the page; keep the last good numbers. */
    if (pinned() && F.length) { docH = document.documentElement.scrollHeight; return; }
    var nr = nav.getBoundingClientRect();
    /* A strip with no box (display: none somewhere up the tree) measures as
       zeros; keep the last good numbers. */
    if (nr.height === 0 && F.length) { docH = document.documentElement.scrollHeight; return; }
    navTop = nr.top; navH = nr.height;
    var sy = window.scrollY;
    F = targets.map(function (t) { var r = t.getBoundingClientRect(); return [r.top + sy, r.bottom + sy]; });
    S = thumbs.map(function (t) { var r = t.getBoundingClientRect(); return [r.top - nr.top, r.bottom - nr.top]; });
    docH = document.documentElement.scrollHeight;
  };
  var toStrip = function (y) {
    if (y <= F[0][0]) return S[0][0];
    for (var i = 0; i < F.length; i++) {
      if (y <= F[i][1]) {
        if (y < F[i][0]) return S[i][0];
        return S[i][0] + (y - F[i][0]) / Math.max(1, F[i][1] - F[i][0]) * (S[i][1] - S[i][0]);
      }
    }
    return S[S.length - 1][1];
  };
  var toPage = function (sy) {
    if (sy <= S[0][0]) return F[0][0];
    for (var i = 0; i < S.length; i++) {
      if (sy <= S[i][1]) return F[i][0] + (sy - S[i][0]) / Math.max(1, S[i][1] - S[i][0]) * (F[i][1] - F[i][0]);
    }
    return F[F.length - 1][1];
  };

  var timer = null, ticking = false, scrubbing = false;
  var show = function () {
    if (!sent.shown) { sent.shown = true; track('strip_shown', { nth: targets.length }); }
    nav.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { if (!scrubbing) nav.classList.remove('is-on'); }, 1000);
  };
  var paint = function () {
    ticking = false;
    if (document.documentElement.scrollHeight !== docH) measure();
    if (pinned()) return;
    /* Past the last photo (the reviews and the rest): no strip. The ring is
       still placed, so it sits at the bottom the moment the photos return. */
    var past = !scrubbing && window.scrollY > F[F.length - 1][1] - 24;
    nav.classList.toggle('is-past', past);
    var top = toStrip(window.scrollY), bottom = toStrip(window.scrollY + window.innerHeight);
    var h = Math.max(24, bottom - top);
    top = Math.min(Math.max(0, top), Math.max(0, navH - h));
    nav.style.setProperty('--ring-top', top.toFixed(1) + 'px');
    nav.style.setProperty('--ring-h', h.toFixed(1) + 'px');
  };
  var onScroll = function () {
    if (!nav.classList.contains('is-past')) show();
    if (!ticking) { ticking = true; requestAnimationFrame(paint); }
  };
  measure(); paint();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); paint(); }, { passive: true });
  window.addEventListener('load', function () { measure(); paint(); });

  /* The finger's spot on the strip names a thumbnail and a fraction of it;
     the matching frame is read live (its real place on the page right now)
     and the page is put there, centred, clamped so it can never run past
     the first or last photo. One scroll per animation frame; the strip
     stays up for as long as the finger is down. */
  var start = null, pendingY = null, scrubRaf = false;
  var scrubTo = function (clientY) {
    var sy = clientY - nav.getBoundingClientRect().top;
    var i = 0, t = 0;
    if (sy <= S[0][0]) { i = 0; t = 0; }
    else if (sy >= S[S.length - 1][1]) { i = S.length - 1; t = 1; }
    else { for (i = 0; i < S.length; i++) { if (sy <= S[i][1]) { t = Math.min(1, Math.max(0, (sy - S[i][0]) / Math.max(1, S[i][1] - S[i][0]))); break; } } }
    var r = targets[i].getBoundingClientRect();
    var y = r.top + window.scrollY + t * r.height - window.innerHeight / 2;
    var first = targets[0].getBoundingClientRect().top + window.scrollY;
    var last = targets[targets.length - 1].getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
    y = Math.max(first, Math.min(Math.max(first, last), y));
    if (Math.abs(y - window.scrollY) >= 1) window.scrollTo(0, y);
  };
  nav.addEventListener('pointerdown', function (e) {
    start = { y: e.clientY, id: e.pointerId, moved: false };
    try { nav.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    show();
  });
  nav.addEventListener('pointermove', function (e) {
    if (!start || e.pointerId !== start.id) return;
    if (!start.moved && Math.abs(e.clientY - start.y) < 3) return;
    if (!start.moved) { start.moved = true; scrubbing = true; nav.classList.remove('is-past'); measure(); }
    e.preventDefault();
    pendingY = e.clientY;
    if (!scrubRaf) { scrubRaf = true; requestAnimationFrame(function () { scrubRaf = false; if (pendingY !== null && scrubbing) scrubTo(pendingY); }); }
  });
  var end = function (e) {
    if (!start || (e && e.pointerId !== start.id)) return;
    var moved = start.moved;
    start = null; scrubbing = false; pendingY = null; show();
    if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    if (moved) { nav.__swallow = true; setTimeout(function () { nav.__swallow = false; }, 350); track('strip_scrub', { label: e && e.type === 'pointercancel' ? 'cancel' : 'drag' }); }
  };
  nav.addEventListener('pointerup', end);
  nav.addEventListener('pointercancel', end);
  nav.addEventListener('click', function (e) {
    if (nav.__swallow) { e.preventDefault(); return; }
    var b = e.target.closest('[data-minimap-i]');
    if (!b) return;
    var i = Number(b.getAttribute('data-minimap-i'));
    if (!(i >= 0 && i < targets.length)) return;
    show();
    track('strip_tap', { label: i === 0 && stage ? '3d' : 'photo', position: i });
    window.scrollTo({ top: targets[i].getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
  });
})();
